module.exports = __webpack_public_path__ + "media/toolkits/icon-4-protect-175a1943.svg";